
import * as constants from "../Constatnts";
import * as actionTypes from "../actionTypes";
import axios from "axios";


export function addNewEmployee(employee) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.post(
        `${constants.API_URL}/staff/employee`,
        employee,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.employee.key;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getActiveEmployees(storeID) {
  return async (dispatch, getState) => {
    // return database.collection("Employees").where("StoreID","==",storeID).where("IsDeleted","==",false).get().then((querySnapshot) => {
    //     const activeEmployees = []
    //     querySnapshot.forEach((doc) => {
    //       activeEmployees.push(
    //           {
    //             key:doc.id,...doc.data()
    //           }
    //         )
    //    })
    //    dispatch({ type: actionTypes.GET_ACTIVE_EMPLOYEES, activeEmployees })
    // }).catch((error) => {
    //     console.log("Error getting employee list: ", error)
    // })
    const token = getState().user.uat;
    const response = await axios.get(
      constants.API_URL + "/staff/employees?storeId=" + storeID,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response && response.data && response.data.activeEmployees) {
      let activeEmployees = response.data.activeEmployees;
      console.log("activeEmployees", activeEmployees);
      dispatch({ type: actionTypes.GET_ACTIVE_EMPLOYEES, activeEmployees });
    }
  };
}


export function getEmployees(
  registrationID,
  storeID,
  from,
  size,
  option,
  searchText,
  searchCity,
  searchState,
  searchCountry,
  searchPinCode,
  searchCustomField1,
  searchCustomField2,
  searchCustomField3,
  searchCustomField4,
  searchCustomField5,
  searchCustomField6,
  searchShowInSales = "",
  searchEmployeeFirstName = "",
  searchEmployeeLastName = "",
  searchEmployeePhoneNo = "",
  searchEmployeeEmailID = "",
  searchEmployeeCode = ""
) {

  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      let apiUrl = "/staff/employee";
      let queryParams = [];



      if (from) {
        queryParams.push(`from=${from}`);
      }
      if (size) {
        queryParams.push(`size=${size}`);
      }




      // Add storeID if provided
      if (storeID) {
        queryParams.push(`storeID=${storeID}`);
      }

      if (searchEmployeeFirstName) {
        queryParams.push(`searchFirstName=${searchEmployeeFirstName}`);
      }
      if (searchEmployeeLastName) {
        queryParams.push(`searchLastName=${searchEmployeeLastName}`);
      }
      if (searchEmployeePhoneNo) {
        queryParams.push(`searchPhoneNo=${searchEmployeePhoneNo}`);
      }
      if (searchEmployeeEmailID) {
        queryParams.push(`searchEmailID=${searchEmployeeEmailID}`);
      }

      // Add option if provided
      if (option) {
        queryParams.push(`option=${option}`);
      }

      // Add search parameters if they exist
      if (searchText) {
        queryParams.push(`searchText=${searchText}`);
      }
      if (searchCity) {
        queryParams.push(`searchCity=${searchCity}`);
      }
      if (searchState) {
        queryParams.push(`searchState=${searchState}`);
      }
      if (searchCountry) {
        queryParams.push(`searchCountry=${searchCountry}`);
      }
      if (searchPinCode) {
        queryParams.push(`searchPinCode=${searchPinCode}`);
      }
      if (searchCustomField1) {
        queryParams.push(`searchCustomField1=${searchCustomField1}`);
      }
      if (searchCustomField2) {
        queryParams.push(`searchCustomField2=${searchCustomField2}`);
      }
      if (searchCustomField3) {
        queryParams.push(`searchCustomField3=${searchCustomField3}`);
      }
      if (searchCustomField4) {
        queryParams.push(`searchCustomField4=${searchCustomField4}`);
      }
      if (searchCustomField5) {
        queryParams.push(`searchCustomField5=${searchCustomField5}`);
      }
      if (searchCustomField6) {
        queryParams.push(`searchCustomField6=${searchCustomField6}`);
      }
      if (searchShowInSales) {
        queryParams.push(`searchShowInSales=${searchShowInSales}`);
      }
      if (queryParams.length > 0) {
        apiUrl += "?" + queryParams.join("&");
      }

      const response = await axios.get(constants.API_URL + apiUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return {
        totalItemsCount: response.data.totalItemsCount,
        searchResult: response.data.employees,
      };
      return response.data;
    } catch (err) {
      console.error("Error fetching employee:", err);
      throw err;
    }
  };
}


export function deleteEmployee(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.delete(
        `${constants.API_URL}/staff/employee/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.code == "0") {
        return true
      }
      return false

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getEmployeeDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/staff/employee/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.code == "0") {
        return response.data.employee
      }
      return {}

    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function updateEmployee(employee, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.put(
        `${constants.API_URL}/staff/employee/${key}`,
        employee,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
      return key;
      }
      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




export function checkIfEmployeeCodeIsUnique(employeeCode,registrationID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.post(
        `${constants.API_URL}/staff/employee-code-check`,
        {
          employeeCode,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.isUnique;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getEmployeeServices(employeeID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/user/getsmployeeservices?EmployeeID=${employeeID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const service = response.data.data[0];

if (!service) {
  return null;
}

const { id, ...rest } = service;

return {
  key: id,
  ...rest,
};
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}




export function saveEmployeeServices(key, objData) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/staff/employee-services/${key}`,
          objData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/staff/employee-services`,
          objData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


